module.exports = __webpack_public_path__ + "static/media/ICICIBANK_F1.8f18d89d.txt";